export const lang = {
  noComment: '亲,有空沙发哦~',
  noMoreData: '--已无更多数据--',
  loadPic: '正在加载图片',
  writeComment: '写评论...',
  writeComment2: '写评论',
  writeComment3: '回复评论...',
  noCommentSelf: '不能回复自己的评论',
  nullComment: '评论为空',
  checkTips: '评论已提交，管理员审核通过后展示~',
  commentSuccess: '评论成功',
  vname: '匿名',
  maxPic: '一次最多允许上传',
  pic: '张图片',
  loading: '加载中...',
  loadingText: '加载中',
  upLoading: '上传中...',
  pullRefresh: '下拉刷新',
  letGoRefresh: '释放刷新',
  yesterday: '昨天',
  one: '星期一',
  two: '星期二',
  three: '星期三',
  four: '星期四',
  five: '星期五',
  six: '星期六',
  seven: '星期天',
  delText: '删除',
  delTip: '刪除成功',
  yes: '确认',
  no: '取消',
  confirmTip: '确认删除?',
  successTip: '成功',
  failTip: '失败', // 11111111111
  read: '已读文章',
  liked: '已点赞文章',
  commented: '已评论文章',
  end: '已无更多数据',
  noData: '暂无数据',
  cancel: '取消',
  refresh: '下拉刷新',
  // detail
  comment: '精彩评论',
  name: '实名',
  send: '发表',
  thirdPlaceholder: '默认匿名评论，可设置昵称',
  takePhoto: '拍照',
  fromPhotos: '从相册选择',
  // rank
  recentRankTitle: '近期热点排行榜',
  lookAllRank: '查看全部排行榜',
  allRankTitle: '全部排行榜',
  error: '访问出错啦~',
  useMidea: '请使用美信访问~',
  showHidingFloor: '展示隐藏楼层',
  all: '全文',
  hide: '收起',
  // article
  articleByTag: '消息标签分类文章列表',
  seeAll: '查看所有',
  replies: '条回复',
  attachmentTip: '附件仅支持PC端下载',
  loadArticleFail: '获取文章失败',
  notExist: '不存在',
  writeAComment: '快来发表你的评论吧',
  canNotSendEmptyComment: '不能发表空内容的评论',
  notFound: '没有找到您所需要的页面...',
  articleDeleted: '该内容已被发布者删除，无法查看',
  notEnoughParam: '参数不足，无法访问',
  contentAddressNotFound: '远程内容地址不存在',
  // content/detail
  contentWriteAComment: '说一说你的想法吧',
  contentComment: '文章评论',
  contentCommentDeleted: '该评论已删除',
  contentNoMoreComment: '没有更多评论了~',
  contentSend: '发布',
  contentAnonymous: '匿名',
  contentNamed: '实名',
  contentCommentAuditing: '发布成功，您的评论已提交审核',
  contentCommentSuccess: '发布成功',
  contentReaded: '浏览',
  onlyMeixinCanOpen: '这个内容只能通过美信打开哦',
  open: '美信打开'
}
